import { render, staticRenderFns } from "./productDealAnaly.vue?vue&type=template&id=13f48674&scoped=true"
import script from "./productDealAnaly.vue?vue&type=script&lang=js"
export * from "./productDealAnaly.vue?vue&type=script&lang=js"
import style0 from "./productDealAnaly.vue?vue&type=style&index=0&id=13f48674&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f48674",
  null
  
)

export default component.exports